export enum IEditPersonalInfoCategory {
  PersonalInfo = 'PersonalInfo',
  ContactInfo = 'ContactInfo',
  EmergencyContact = 'EmergencyContact',
  ApplicationQuestions = 'ApplicationQuestions',
}
